export function isPhraseEnabled() {
    return window.PHRASEAPP_ENABLED;
}

export function escapeId(id) {
    const { prefix, suffix } = window.PHRASEAPP_CONFIG;
    return `${prefix}phrase_${id}${suffix}`;
}
